import React from 'react';
import PropTypes from 'prop-types';
import {
  Anchor,
  Badge,
  MandarkTable,
  MandarkTableContext,
  NoDataMsg,
  WithTooltip
} from '@albert-io/atomic';

import ManageRosterContext from 'client/Classrooms/Classroom/Teacher/ManageRoster/ManageRoster.context';
import HardCapWarningBanner from 'client/components/HardCapWarningBanner/HardCapWarningBanner.react';

import InviteStudentsCards from '../EmptyStates/InviteStudentsCards.react';
import InviteDropdownBtn from '../InviteDropdownBtn/InviteDropdownBtn.react';

import EnrolledStudentsActionsDropdown from './EnrolledStudentsActionsDropdown/EnrolledStudentsActionsDropdown.react';

import './enrolled-students.scss';

function getSearchFilters(query, term) {
  const terms = term.split(' ').filter((str) => str); // Filter out any spaces

  const queryWithFilters = terms.reduce((prev, curr) => {
    const encodedTerm = encodeURIComponent(curr);
    return prev.filter({
      all_of: [
        {
          any_of: [
            {
              first_name: {
                case_insensitive_substring: encodedTerm
              }
            },
            {
              last_name: {
                case_insensitive_substring: encodedTerm
              }
            },
            {
              email: {
                case_insensitive_substring: encodedTerm
              }
            }
          ]
        }
      ]
    });
  }, query);

  return queryWithFilters;
}

export default class EnrolledStudents extends React.Component {
  static propTypes = {
    params: PropTypes.object
  };

  static contextType = ManageRosterContext;

  render() {
    const {classroom, invitations, students} = this.context;

    if (students.isEmpty() && invitations.isEmpty()) {
      return <InviteStudentsCards />;
    }

    if (students.isEmpty() && !invitations.isEmpty()) {
      return (
        <NoDataMsg.Container>
          <NoDataMsg.Heading>Invitations pending</NoDataMsg.Heading>
          <NoDataMsg.Body className='u-mar-b_5'>
            Some or all invited students have not accepted their invitations. To re-send
            invitations, go to the{' '}
            <Anchor to={`/classes/${this.props.params.classId}/people/students/invited`}>
              Invited
            </Anchor>{' '}
            tab.
          </NoDataMsg.Body>
        </NoDataMsg.Container>
      );
    }

    const school = classroom.getSchool();
    return (
      <>
        {classroom.getSchool().isHardCap() && (
          <HardCapWarningBanner
            rounded
            seatsRemaining={classroom.getMeta().getCountOfSchoolLicenseSeatsRemaining()}
            className='u-mar-b_4'
          />
        )}
        <MandarkTable
          buttonGroup={<InviteDropdownBtn />}
          query={this.context.queries.students}
          searchFilters={getSearchFilters}
          persistPage
          theme='list'
          title='Enrolled'
        >
          <MandarkTable.Column
            heading='Last Name'
            content={(student) => student.getLastName()}
            sortBy='last_name'
          />
          <MandarkTable.Column
            heading='First Name'
            content={(student) => student.getFirstName()}
            sortBy='first_name'
          />
          <MandarkTable.Column
            className='u-word-break_break-all'
            heading='Email'
            content={(student) => student.getEmail()}
            sortBy='email'
          />
          <MandarkTableContext.Consumer>
            {({data}) => {
              if (!data) {
                return null;
              }
              const showManagedAccountIndicator = data.some((student) =>
                student.getMeta().isManagedUser()
              );
              return showManagedAccountIndicator ? (
                <MandarkTable.Column
                  align='center'
                  className='enrolled-students-table__badge-wrapper'
                  content={(student) =>
                    student.getMeta().isManagedUser() ? (
                      <WithTooltip content={`Managed by ${school.getName()}`}>
                        <Badge iconAlign='center' icon={['far', 'school']} />
                      </WithTooltip>
                    ) : null
                  }
                />
              ) : null;
            }}
          </MandarkTableContext.Consumer>
          <MandarkTable.Column
            align='center'
            isActionMenu
            content={(student) => (
              <EnrolledStudentsActionsDropdown classroom={classroom} student={student} />
            )}
          />
        </MandarkTable>
      </>
    );
  }
}
